import Auth from "@/components/General/Auth/auth";
import router from "@/router";

export const ReportExportsAuth = (error, routeName) => {
  if (typeof error.response !== "undefined" && error.response.status === 401) {
    Auth.logout();
    router.push({ name: routeName });
  }
};
